import { useBrandConfiguration } from '@search/core/brands/context';
import { getAnalyticsContainedData } from '@search/core/helpers/getAnalyticsContainedData';
import { useApis } from '@search/core/hooks/useApis';
import { postContainedClassifieds } from '@search/core/services/analytics';
import { useEffect } from 'react';
import { useAppContext } from '../../../contexts/AppContext';
export const useContainedClassifieds = () => {
    const [searchIndex, classifiedIds, page, totalCount, order] = useAppContext((store) => [
        store.searchIndex,
        store.classifieds,
        store.page,
        store.totalCount,
        store.order,
    ]);
    const { analytics: { portal }, } = useBrandConfiguration();
    const { bffUri } = useApis();
    useEffect(() => {
        if (classifiedIds.length === 0)
            return;
        postContainedClassifieds({
            analyticsData: getAnalyticsContainedData({ place: 'SERP_PAGE', classifiedIds, order, page, portal, totalCount }),
            bffUri,
        });
    }, [searchIndex]);
};
